import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {
  Flex,
  Stack,
  Text,
  Button,
  Divider,
  Icon,
} from "@chakra-ui/react";
import { ReactComponent as LeftArrow } from "../../../assets/icons/left-arrow.svg";

import WithAppLayout from "../../../components/WithAppLayout";
import PageTitle from "../../../components/PageTitle";
import JobRequirementsEditor from "../../../components/JobRequirementsEditor";
import colors from "../../../helpers/colors";
import { JOB_DETAILS_PATH } from "../../../routes";
import { JOB_CRITERIA_QUERY } from "../../../graphql/jobs";

function ScreeningCriteriaReviewInner() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data } = useQuery(JOB_CRITERIA_QUERY, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });

  const extractionStatus = data?.moblyzeJob?.criteriaExtractionStatus;
  const isProcessing = !extractionStatus || extractionStatus === "Started";
  const isFailed = extractionStatus === "Failed";

  const handleDone = () => {
    navigate(JOB_DETAILS_PATH.replace(":id", id));
  };

  return (
    <Flex direction="column" maxW="800px">
      <Button
        onClick={handleDone}
        variant="link"
        fontSize="md"
        lineHeight="6"
        fontWeight="normal"
        color="blue.300"
        mb={4}
        alignSelf="flex-start"
        leftIcon={
          <Icon
            fontSize="14px"
            position="relative"
            top="2px"
            as={LeftArrow}
          />
        }
        _hover={{ color: "blue.200", textDecoration: "underline" }}
      >
        Back
      </Button>

      <PageTitle title="Matching Criteria" />
      <Text fontSize="sm" color="whiteAlpha.900" mt={2} mb={2}>
        These requirements will be used to filter and screen candidates (they don&apos;t appear on the job post).
      </Text>

      <Divider mt={4} mb={6} />

      <JobRequirementsEditor moblyzeJobId={id} pollWhileProcessing />

      {!isProcessing && !isFailed && (
        <>
          <Divider mt={8} mb={6} />
          <Stack spacing={2} align="flex-start">
            <Button
              backgroundColor={colors.white}
              color={colors.greyDark}
              _hover={{ backgroundColor: colors.white }}
              onClick={handleDone}
            >
              Start matching
            </Button>
            <Text fontSize="sm" color="whiteAlpha.700">
              We&apos;ll search for candidates who meet these criteria. This usually takes 30–60 seconds.
            </Text>
          </Stack>
        </>
      )}
    </Flex>
  );
}

export default WithAppLayout(ScreeningCriteriaReviewInner);
